import * as React from "react";
import { HeaderWithNav } from "../../../../../HeaderWithNav";
import { HeaderLogoAndTel } from "../../../../../HeaderLogoAndTel";
import * as main from "../../../styles/main.module.scss";
import * as screen1 from "./screen1.module.scss";
import navData from "../../../data/navData.json";
import useMediaQuery from '@mui/material/useMediaQuery';


export const Screen1 = ({ targetGroup, titleText, subTitleText, usualHeader=false, headerBtnText="Купить курс", mainBtnText="Купить курс", sravni }) => { // 5-7 = kids,
  // 8-11 =
  // teens
  const isLaptop = useMediaQuery('(max-width:991px)');

  const isMobile = useMediaQuery('(max-width:767px)');
  return (
    <header
      className={screen1.screen1}
      style={{
        backgroundImage:
          (targetGroup === "teens") ?
            (isMobile ? "url(https://fs.advance.ru/landing-pages/online/uchis_uchitsya/bg-uu-8-11-320.jpg)"
              : isLaptop ? "url(https://fs.advance.ru/landing-pages/online/uchis_uchitsya/bg-uu-8-11-768.jpg)"
              : "url(https://fs.advance.ru/landing-pages/online/uchis_uchitsya/bg-uu-8-11-1920.jpg)")
            :
            (targetGroup === "kids") ?
              (isMobile ? "url(https://fs.advance.ru/landing-pages/online/uchis_uchitsya/bg-uu-5-7-320.png)"
                : isLaptop ? "url(https://fs.advance.ru/landing-pages/online/uchis_uchitsya/tablet-screen1.png)"
                  : "url(https://fs.advance.ru/landing-pages/online/uchis_uchitsya/bg-uu-5-7-1920.jpg)")
              :
              null
      }}
    >
      <div className="container">

        {
          !usualHeader ?
            <HeaderWithNav
              data={navData}
              buttonText={headerBtnText}
              modal={false}
              noContainer={true}
              noLink={sravni}
            />
            :
            <HeaderLogoAndTel/>
        }

        <div className={screen1.screen1__container}>
          <div className={screen1.screen1__titleWrapper}>
            <h1 className={screen1.screen1__title}>
              {
                !titleText ?
                  (
                    targetGroup === "teens" ?
                      "Курс «Учись Учиться 8–11 класс»"
                      :
                      targetGroup === "kids" ?
                        "Курс «Учись Учиться 5–7 класс»"
                        :
                        "Курс «Учись Учиться"
                  )
                :
                  (
                    titleText
                  )
              }
            </h1>
            <h2 className={screen1.screen1__subtitle}>
              {
                subTitleText ? subTitleText : "Инструменты для успеха в школе и в жизни"
              }
            </h2>
            <ul className={screen1.screen1__list}>
              <li className={screen1.screen1__item}>Научим учиться легко и с удовольствием</li>
              <li className={screen1.screen1__item}>Поднимем мотивацию, любознательность и уверенность в своих силах
              </li>
              <li className={screen1.screen1__item}>Все это в формате игры с сюжетом и множеством практических упражнений</li>
            </ul>
          </div>
          <div className={`row ${screen1.screen1__infoWrapper}`}>
            <div className={`col-12 col-md-6 ${screen1.screen1__infoCol}`}>
              <p className={screen1.screen1__text}>Рекомендован
                Навигатором образования Минпросвещения РФ и Смартекой</p>
              <div className={screen1.screen1__imageWrapper}>
                <img className="screen1__image"
                     src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/logo-minprosvet.svg"
                     alt="Минпросвещения России" width="120%" height="auto"/>
                <img className="screen1__image"
                     src="https://fs.advance.ru/landing-pages/online/uchis_uchitsya/logo-smarteka.png" alt="Смартека"
                     width="85%" height="auto"/>
              </div>
            </div>
          </div>
          <div className={screen1.screen1__linkWrapper}>
            <a className={`${screen1.screen1__link} ${main.mainBtn}`} href="#user-action" data-target="#user-action">
              {mainBtnText}
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};
